
import { Space, Table, Popconfirm, Row, Col, Input, Descriptions, Statistic, Card, message, Menu, Dropdown } from "antd"
import { useState, useEffect } from "react"
import { PlusCircleTwoTone, IdcardTwoTone, CreditCardTwoTone, DownOutlined } from '@ant-design/icons';
import { reqGetCompanyList, reqAssignNumAdd, reqAssignCard, reqEditSubCompany, reqDeleteCompany } from "../../../api"
import LinkButton from "../../../components/link-button"
import AssignNumAdd from "./assign-num-add"
import RollBackNumAdd from "./rollback-num-add/rollback-num-add"
import AssignCard from "./assign-card"
import EditSubCompany from "./edit-subcompany"
import {delete_company_by_id} from "../../../redux/actions"
import "./index.less"
import { connect } from "react-redux";
const CompanyList = props => {
  //当前编辑公司
  const [currentEdit, setCurrentEdit] = useState({})
  const [companyList, setCompanyList] = useState([])
  const [companyInfo, setCompanyInfo] = useState([])
  const [loading, setLoading] = useState(false)
  //搜索关键字
  const [keyWord, setKeyWord] = useState('')
  //显示分配添加用户
  const [showAssignNumAdd, setShowAssignNumAdd] = useState(false)
  const [showRollBackNumAdd, setShowRollBackNumAdd] = useState(false)
  //分配添加用户打开模态框
  const openAssignNumAdd = (record) => {
    setShowAssignNumAdd(true)
    setCurrentEdit(record)
  }
  const openRollBackNumAdd = (record) => {
    setShowRollBackNumAdd(true)
    setCurrentEdit(record)
  }
  //分配添加用户关闭模态框
  const closeAssignNumAdd = () => {
    setShowAssignNumAdd(false)
  }
  const closeRollBackNumAdd = () => {
    setShowRollBackNumAdd(false)
  }
  //确认分配可添加用户数
  const assignNumAdd = async (values) => {
    const res = await reqAssignNumAdd(currentEdit.company_id, values.assign_count)
    if (res.data?.result === 1) {
      message.success("分配成功")
      // const num_add_users = companyInfo.num_add_users - values.assign_count
      // setCompanyInfo({ ...companyInfo, num_add_users })
      updateTable()
      closeAssignNumAdd()
    } else {

    }
  }
  //收回可添加用户数
  const rollBackNumAdd = async (values) => {
    const res = await reqAssignNumAdd(currentEdit.company_id, -values.assign_count)
    if (res.data?.result === 1) {
      message.success("收回成功")
      // const num_add_users = companyInfo.num_add_users - values.assign_count
      // setCompanyInfo({ ...companyInfo, num_add_users })
      updateTable()
      closeRollBackNumAdd()
    } else {

    }
  }
  //显示分配年卡
  const [showAssignCard, setShowAssignCard] = useState(false)
  const openAssignCard = (record) => {
    setShowAssignCard(true)
    setCurrentEdit(record)
  }
  const closeAssignCard = () => {
    setShowAssignCard(false)
  }
  // /确认分配年卡
  const assignCard = async (values) => {
    let options = {}
    const { card_type, count, operation_type, remarks } = values
    options.company_id = currentEdit.company_id
    options[`assign_${card_type}_cards`] = count
    options[`assign_${card_type}_type`] = operation_type
    options[`assign_${card_type}_remarks`] = remarks
    const res = await reqAssignCard(options)
    if (res.data?.result === 1) {
      message.success("分配成功")
      setCompanyInfo({ ...companyInfo, [`${card_type}_cadrs_count`]: companyInfo[`${card_type}_cadrs_count`] - count })
      closeAssignCard()
    } else {
      message.error(res.data.err_msg)
    }
  }
  const [showEditSubCompany, setShowEditSubCompany] = useState(false)
  const openEditSubCompany = record => {
    setShowEditSubCompany(true)
    setCurrentEdit(record)
  }
  const closeEditSubCompany = () => {
    setShowEditSubCompany(false)
  }
  const editSubCompany = async (values) => {
    values.company_id = currentEdit.company_id
    const res = await reqEditSubCompany(values)
    if (res.data?.result === 1) {
      message.success("修改成功")
      closeEditSubCompany()
    } else {
      message.error("操作失败")
    }

  }
  const confirmDeleteCompany = async (record) => {
    const { company_id } = record
    const res = await reqDeleteCompany(company_id)
    if (res.data?.result === 1) {
      message.success("删除成功")
      updateTable()
      //更新redux
      props.delete_company_by_id(company_id)
    } else {
      message.error(res.data?.err_msg)
    }
  }
  //刷新表格
  const updateTable = async () => {
    const res = await reqGetCompanyList(undefined, keyWord)
    setCompanyList(res.data.subcompany_list)
    setCompanyInfo(res.data.company_info)
  }
  const onSearch = async (value) => {
    setKeyWord(value)
    const res = await reqGetCompanyList(undefined, value)
    setCompanyList(res.data.subcompany_list)
  }
  useEffect(() => {
    const getCompanyList = async () => {
      setLoading(true)
      const res = await reqGetCompanyList()
      setLoading(false)
      setCompanyList(res.data.subcompany_list)
      setCompanyInfo(res.data.company_info)
    }
    getCompanyList()
  }, [])
  const columns = [
    {
      title: '公司名称',
      dataIndex: 'company_name',
      key: 'company_name',
      align: 'center',
    },
    {
      title: '账号数量',
      dataIndex: 'user_count',
      key: 'user_count',
      align: 'center',
      sorter: (a, b) => a.user_count - b.user_count,
    },
    {
      title: '群组数量',
      dataIndex: 'group_count',
      key: 'group_count',
      align: 'center',
      sorter: (a, b) => a.group_count - b.group_count,
    },
    {
      title: '账号预警数量',
      dataIndex: 'alarm_count',
      key: 'alarm_count',

      align: 'center',
      sorter: (a, b) => a.alarm_count - b.alarm_count,
    },
    {
      title: '过期账号',
      dataIndex: 'expire_count',
      key: 'expire_count',

      align: 'center',
      sorter: (a, b) => a.expire_count - b.expire_count,
    },
    {
      title: "剩余添加用户数",
      dataIndex: "num_add_users",
      key: "num_add_users",
      width: 160,
      align: 'center',
      sorter: (a, b) => a.num_add_users - b.num_add_users,
    }, {
      title: "操作",
      align: 'center',
      width: 400,
      render: (record) => {
        return (
          <Space>
            <Dropdown
              overlay={<Menu>
                <Menu.Item>
                  <LinkButton onClick={() => { openAssignNumAdd(record) }}>分配</LinkButton>
                </Menu.Item>
                <Menu.Item>
                  <LinkButton onClick={() => { openRollBackNumAdd(record) }}>回收</LinkButton>
                </Menu.Item>
              </Menu>}
            >
              <a className="ant-dropdown-link">
                添加用户数 <DownOutlined />
              </a>
            </Dropdown>
            {/* <LinkButton onClick={() => { openAssignNumAdd(record) }}>分配可添加用户数</LinkButton> */}
            {/* <LinkButton onClick={() => { openAssignNumAdd(record) }}>回收可添加用户数</LinkButton> */}
            <LinkButton onClick={() => { openAssignCard(record) }}>分配充值卡</LinkButton>
            <LinkButton onClick={() => { openEditSubCompany(record) }}>修改</LinkButton>
            <Popconfirm
              title="公司删除后不可恢复"
              onConfirm={() => { confirmDeleteCompany(record) }}
              okText="删除"
              cancelText="取消"
            >
              <LinkButton >删除</LinkButton>
            </Popconfirm>
          </Space>
        )
      }
    }

  ]
  return <div className="company-list">
    <AssignNumAdd visible={showAssignNumAdd} onCancel={closeAssignNumAdd} onSubmit={assignNumAdd} existingNum={companyInfo.num_add_users} currentEdit={currentEdit} />
    <RollBackNumAdd visible={showRollBackNumAdd} onCancel={closeRollBackNumAdd} onSubmit={rollBackNumAdd} currentEdit={currentEdit} />
    <AssignCard visible={showAssignCard} onCancel={closeAssignCard} onSubmit={assignCard} currentEdit={currentEdit} />
    <EditSubCompany visible={showEditSubCompany} onCancel={closeEditSubCompany} onSubmit={editSubCompany} currentEdit={currentEdit} />
    <div className="company-list-title">

      <Card title="公司信息"
        loading={loading}
        bordered={false}
      // extra={<LinkButton href="#">编辑</LinkButton>}
      >
        <Descriptions>
          <Descriptions.Item label="用户名">{companyInfo.user_account}</Descriptions.Item>
          <Descriptions.Item label="公司名称">{companyInfo.company_name}</Descriptions.Item>
          <Descriptions.Item label="电话">{companyInfo.phone_num}</Descriptions.Item>
        </Descriptions>,
    <Row >
          <Col span="4"><Statistic prefix={<IdcardTwoTone twoToneColor="#00B5CF" />} title="子公司数量" value={companyInfo.subcompany_count} /></Col>
          <Col span="4"><Statistic prefix={<PlusCircleTwoTone twoToneColor="#FC03E8" />} title="可添加用户数" value={companyInfo.num_add_users} /></Col>
          <Col span="4"> <Statistic prefix={<CreditCardTwoTone twoToneColor="#FA031C" />} title="永久卡数" value={companyInfo.perm_cadrs_count} /></Col>
          <Col span="4"> <Statistic prefix={<CreditCardTwoTone twoToneColor="#F76208" />} title="年卡数" value={companyInfo.year_cadrs_count} /></Col>
          <Col span="4"> <Statistic prefix={<CreditCardTwoTone twoToneColor="#009AB0" />} title="月卡数" value={companyInfo.month_cadrs_count} /></Col>
        </Row>
      </Card>
    </div>
    <div className="company-list-table">
      <Table columns={columns}
        size="small"
        rowKey="company_id"
        loading={loading}
        pagination={{
          defaultPageSize: 30,
          total: companyList.length,
          showSizeChanger: true,
          showQuickJumper: true,
          position: ["bottomCenter"],
          pageSizeOptions: [10, 30, 50, 100],
          showTotal: total => `总记录： ${total} 条`
        }}
        dataSource={companyList}
        sticky
        title={() => {
          return (
            <Input.Search allowClear onSearch={onSearch} placeholder="输入子公司名称搜索" style={{ width: 300, marginLeft: 10 }} />
          )
        }}
        bordered
      >
      </Table>
    </div>
  </div>
}
export default connect(
  null,
  {delete_company_by_id}
)(CompanyList) 